module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"uralys.com","short_name":"www","start_url":"/","background_color":"#1c2541","theme_color":"#1c2541","display":"minimal-ui","icon":"src/images/global/logo-square.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"9285bf46e8a29e148ddbd458940fc1bc"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-17389126-1"},
    }]
